import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//impoertacion componentes

import {
  creaGerente,
  obtenerDepartamento,
  obtenerInstituciones,
  obtenerTipoDocumento,
} from "../../Services/Rest";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

function CreaGerente() {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [tipoDocumento, setTipoDocumento] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerTipoDocumento,
    })
      .then((Response) => {
        setTipoDocumento(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setTipoDocumento]);
  const [departamento, setDepartamento] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerDepartamento,
    })
      .then((Response) => {
        setDepartamento(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setDepartamento]);
  const [institucion, setInstitucion] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerInstituciones,
    })
      .then((Response) => {
        setInstitucion(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setInstitucion]);

  const [postTipoDocumento, setPostTipoDocumento] = useState([]);

  const [postDepartamento, setPostDepartamento] = useState([]);
  const [postInstitucion, setPostInstitucion] = useState([]);
  const [postNombre, setPostNombre] = useState([]);
  const [postDocumento, setPostDocumento] = useState([]);
  const [postTelefono, setPostTelefono] = useState([]);
  const [postDireccion, setPostDireccion] = useState([]);
  const [postCorreo, setPostCorreo] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      url: "https://suadesarrollo.azurewebsites.net/api/CrearGerente",
      data: {
        Nombre: postNombre,
        Tipo_Documento: postTipoDocumento,
        Documento: postDocumento,
        Telefono_Contacto: postTelefono,
        ciudad: postDepartamento,
        Direccion: postDireccion,
        InstitucionId: cookies.get("institucionid"),
        correo: postCorreo,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          title: "Creado con exito",
          text: "Haga clic para continuar",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload("/");
        });
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear Institucion " + error);
      });
  };
  console.log(postNombre);
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear CreaGerente
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Nombre"
                            onChange={(e) => setPostNombre(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) =>
                              setPostTipoDocumento(e.target.value)
                            }
                          >
                            <option value="">Tipo Documento</option>
                            {tipoDocumento.map((item) => (
                              <option value={item.id}>
                                {item.tipo_Documento}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-6">
                          <input
                            type="number"
                            className="form-control form-control-user"
                            placeholder="Documento"
                            onChange={(e) => setPostDocumento(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Telefono de contacto"
                            onChange={(e) => setPostTelefono(e.target.value)}
                          />
                        </div>
                        <div className="col-sm-6 ">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) =>
                              setPostDepartamento(e.target.value)
                            }
                          >
                            <option value="">Seleccione Departamento</option>
                            {departamento.map((item) => (
                              <option value={item.departamento}>
                                {item.departamento}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="direccion"
                            onChange={(e) => setPostDireccion(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control form-control-user"
                          placeholder="correo"
                          onChange={(e) => setPostCorreo(e.target.value)}
                        />
                      </div>
                      <a>
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={postData}
                        >
                          Guardar
                        </button>
                      </a>
                      <hr />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaGerente;
